import request from '../utils/request';

export const jadeIdentificationServiceApi = {
  pageList: (params) => {
    return request({
      url: '/jade-identification-service/list',
      method: 'post',
      data: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        ...params
      }
    });
  },

  getById: (id) => {
    return request({
      url: `/jade-identification-service/${id}`,
      method: 'get'
    });
  },

  create: (data) => {
    return request({
      url: '/jade-identification-service',
      method: 'post',
      data: {
        serviceName: data.serviceName,
        serviceCode: data.serviceCode,
        description: data.description || null,
        price: data.price || null,
        duration: data.duration || null,
        status: data.status || 'ENABLED',
        ...data
      }
    });
  },

  update: (id, data) => {
    return request({
      url: `/jade-identification-service/${id}`,
      method: 'put',
      data: {
        serviceName: data.serviceName,
        serviceCode: data.serviceCode,
        description: data.description || null,
        price: data.price || null,
        duration: data.duration || null,
        status: data.status || 'ENABLED',
        ...data
      }
    });
  },

  delete: (id) => {
    return request({
      url: `/jade-identification-service/${id}`,
      method: 'delete'
    });
  }
};

export default jadeIdentificationServiceApi;